// extracted by mini-css-extract-plugin
export default {"infoTag":"infoTag_infoTag__TcCRQ"};